import React, { useEffect, useRef, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useModal } from "contexts/modalContext/modalContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";

import "./fixDomainModal.scss";

const FixDomainModal = ({
  mails,
  formBody,
  callback,
  setBody,
  setEnableSubmit,
}) => {
  const { getHtmlByKey, getTextByKey } = useContent();
  const { closeModal } = useModal();

  const [newMails, setNewMails] = useState(formBody.SendToEmail);

  const wasSubmittedRef = useRef(false);

  const handleSubmit = () => {
    wasSubmittedRef.current = true;
    const newData = { ...formBody, SendToEmail: newMails };
    setBody(newData);
    callback(newData);
    closeModal();
  };

  const handleClose = () => {
    setEnableSubmit(true);
    closeModal();
  };

  // replacing old domain with new one
  const handleFixDomainAction = ({ oldVal, newVal }) => {
    const newMailsArr = [...newMails];
    const index = newMailsArr.indexOf(oldVal);
    newMailsArr[index] = newVal;
    setNewMails(newMailsArr);
  };

  const handleReplaceAll = () => [
    setNewMails((prev) => {
      return prev.map((mail) => {
        if (mails[mail]) return mails[mail];
        return mail;
      });
    }),
  ];

  // test@gmial.com, test1@gmial.com, test2@gmial.com, test3@gmial.com, test4@gmial.com, test5@gmial.com, test6@gmial.com, test7@gmial.com, test8@gmial.com

  return (
    <div className="fix-domain-modal-container">
      <button className="close-button" onClick={handleClose}>
        <Icon name="x" />
      </button>
      <div className="fix-domain-modal-header">
        {getHtmlByKey("fix-domain-title")}
        <span className="sub-text">{getHtmlByKey("fix-domain-sub-text")}</span>
      </div>
      <div className="fix-domain-modal-body">
        {Object.entries(mails).map(([oldMail, newMail]) => {
          return (
            <div
              className={`email-item${
                newMails.includes(newMail) ? " changed" : ""
              }`}
              key={oldMail}
            >
              <div className="mails-values">
                <div className="old">{oldMail}</div>
                <i className="fas fa-arrow-right"></i>
                <div className="new">{newMail}</div>
              </div>
              <Tooltip tooltipTextKey="fix-domain-action-tooltip">
                <div
                  className={`icon-container`}
                  onClick={() =>
                    handleFixDomainAction({ oldVal: oldMail, newVal: newMail })
                  }
                >
                  <Icon name="check"></Icon>
                </div>
              </Tooltip>
            </div>
          );
        })}
      </div>
      <button className="fix-all" onClick={handleReplaceAll}>
        {getTextByKey("fix-all")}
      </button>
      <div className="fix-domain-modal-footer">
        <Button onClick={handleSubmit}>{getTextByKey("continue")}</Button>
      </div>
    </div>
  );
};

export default FixDomainModal;
